import React from 'react'


import HasPermissions from '../../../../../../common-components/HasPermissions'

import {
  RequestLocalReleaseAuthorizationOption,
  ReportInventoryOption,
  ManageUsersOption,
  ManageContactsAndSubscriptionsOption,
  ManageAddressesOption,
  // ManageProjectionsOption,
} from '../../shared/IndividualOptions'

import {
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_MANAGE_USERS_AND_CONTACTS,
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_VIEW_ADDRESSES,
} from '../../../../../../constants/permissions'

import {
  TEMPORARILY_DISABLE_CONTACTS_FEATURE,
} from '../../../../../../config'

// CODE_COMMENTS_39
export default ({
  customerId,
  shouldReportInventoryFormBeRendered,
}) => ([
  <RequestLocalReleaseAuthorizationOption
    key="RequestLocalReleaseAuthorizationOption"
    customerId={customerId}
  />,
  ...(
    shouldReportInventoryFormBeRendered
      ? [<ReportInventoryOption isDistributor key="ReportInventoryOption" />]
      : []
  ),
  <HasPermissions
    key="ManageUsersOption"
    requiredPermissions={FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_MANAGE_USERS_AND_CONTACTS}
    renderIfHasPermissions={
      () => (
        <ManageUsersOption />
      )
    }
  />,
  ...(!TEMPORARILY_DISABLE_CONTACTS_FEATURE
    ? [
      <HasPermissions
        key="ManageContactsAndSubscriptionsOption"
        requiredPermissions={FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_MANAGE_USERS_AND_CONTACTS}
        renderIfHasPermissions={
          () => (
            <ManageContactsAndSubscriptionsOption />
          )
        }
      />,
    ]
    : []
  ),
  <HasPermissions
    key="ManageAddressesOption"
    requiredPermissions={FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_VIEW_ADDRESSES}
    renderIfHasPermissions={
      () => (
        <ManageAddressesOption />
      )
    }
  />,
])
